// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { memo } from 'preact/compat';
export const memoNamed = (displayName, 
// eslint-disable-next-line @typescript-eslint/prefer-readonly-parameter-types
fc) => {
    const mut_memoizedComponent = memo(fc);
    mut_memoizedComponent.displayName = displayName;
    return mut_memoizedComponent;
};
